module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 35 35"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "Слой_2",
      "data-name": "Слой 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Слой_1-2",
      "data-name": "Слой 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M35,17.51A17.5,17.5,0,1,1,17.52,0,17.52,17.52,0,0,1,35,17.51ZM4.13,16.57h.63c.21,0,.42,0,.62,0a.93.93,0,0,1,.89,1.07.92.92,0,0,1-1,.79q-1.18,0-2.37,0c-.23,0-.32.06-.27.3s.05.53.09.79a14.88,14.88,0,0,0,29.57-.75c0-.3-.07-.35-.33-.34-.79,0-1.58,0-2.37,0a.93.93,0,0,1,.1-1.85c.78,0,1.56,0,2.34,0,.23,0,.3-.06.28-.29a17,17,0,0,0-.68-3.67c-.07-.25-.16-.33-.43-.21-.73.33-1.47.62-2.21.93a.55.55,0,0,1-.7-.12.54.54,0,0,1,.24-.9c.76-.32,1.52-.64,2.29-.94.25-.1.28-.2.17-.43a14,14,0,0,0-2.3-3.44c-.16-.18-.25-.2-.43,0-.57.6-1.16,1.18-1.74,1.76-.17.16-.36.33-.58.23s-.34,0-.44.22Q23.76,12.87,22,16a.53.53,0,0,0-.06.46,4.23,4.23,0,0,1-.23,2.76,4.53,4.53,0,1,1-3.26-6.19.62.62,0,0,0,.5,0q3.25-1.86,6.53-3.69c.11-.06.2-.11.13-.27a.6.6,0,0,1,.21-.69c.56-.55,1.11-1.12,1.68-1.67.19-.18.22-.28,0-.46A14.94,14.94,0,0,0,24,4.15c-.2-.09-.29-.08-.38.14-.27.7-.57,1.4-.86,2.1-.17.39-.44.52-.77.38s-.42-.42-.26-.82c.28-.68.55-1.35.84-2,.09-.2.09-.29-.15-.37a19.87,19.87,0,0,0-3.66-.7c-.22,0-.28,0-.28.26q0,1.08,0,2.16a.93.93,0,1,1-1.86,0q0-1.06,0-2.13c0-.26-.07-.32-.31-.3a17.72,17.72,0,0,0-3.63.66c-.23.07-.28.14-.18.36.3.68.58,1.37.86,2.06.17.42.09.7-.25.85s-.61,0-.78-.41c-.3-.71-.59-1.42-.88-2.13-.07-.19-.14-.25-.35-.16A14.83,14.83,0,0,0,7.46,6.26c-.18.15-.18.24,0,.4.6.58,1.19,1.18,1.78,1.77a.67.67,0,0,1,.06,1c-.22.22-.51.17-.84-.16-.61-.6-1.21-1.19-1.8-1.81-.17-.17-.26-.17-.43,0a14.09,14.09,0,0,0-2.13,3.17c-.3.61-.29.61.34.87l1.77.73.38.17a.52.52,0,0,1,.31.63.58.58,0,0,1-.66.39,1.89,1.89,0,0,1-.36-.11c-.74-.3-1.47-.6-2.19-.91-.2-.09-.28-.08-.35.14a17.61,17.61,0,0,0-.68,3.81c0,.18,0,.25.22.24C3.29,16.56,3.71,16.57,4.13,16.57Zm13.35,3.58a2.65,2.65,0,1,0-2.63-2.71A2.63,2.63,0,0,0,17.48,20.15Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M18.13,31.59c-7.55,0-13.53-5.12-14.54-11.86,0-.31,0-.35.3-.34s.82,0,1.22,0,.33.08.38.32A11.91,11.91,0,0,0,11.24,28,12.2,12.2,0,0,0,29.5,19.75c.05-.29.15-.38.45-.36s.81,0,1.22,0c.23,0,.29.05.25.29a13.7,13.7,0,0,1-3.09,6.81A13.66,13.66,0,0,1,18.13,31.59Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M11.75,19.39c.68-.16,1,.13,1.36.74a4.82,4.82,0,0,0,4.56,2.5,5,5,0,0,0,4.46-2.91c.13-.24.24-.35.52-.33s.84,0,1.25,0,.34.06.25.33a7,7,0,0,1-13.27.07c-.14-.4-.14-.4.28-.4Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba73d51e","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/detector.vue
// module id = c514241080b880743ea4
// module chunks = 89